import { Component, Injector, ChangeDetectionStrategy } from '@angular/core'
import { AbstractComponent } from 'lib-trend-core'

@Component({
    // templateUrl: './tracking.component.html',
    templateUrl: './tracking.v2.component.html',
    styleUrls: ['./tracking.component.scss', './tracking.v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TrackingComponent extends AbstractComponent {

  constructor(injetor: Injector) {
    super(injetor)
  }

  viewReportTracking(): void {
    this.router.navigate([`report/view-tracking`])
  }

}
